import { render, staticRenderFns } from "./ListaBrindes.vue?vue&type=template&id=79cec77b&scoped=true"
import script from "./ListaBrindes.vue?vue&type=script&lang=js"
export * from "./ListaBrindes.vue?vue&type=script&lang=js"
import style0 from "./ListaBrindes.vue?vue&type=style&index=0&id=79cec77b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cec77b",
  null
  
)

export default component.exports